import PropTypes from 'prop-types'
import {
  Children,
  memo,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react'
import { TableContext } from 'components/table/Table'
import { isEmpty } from 'utils'

const Head = memo(({ noHead = false, children }) => {
  const {
    error,
    rows,
    columns,
    setColumns,
    setHasCheckbox,
    headerHeight,
    setHeaderHeight,
    mergeHeadersOnNoContent,
  } = useContext(TableContext)
  useEffect(() => {
    const childrenArray = Children.toArray(children)
    setColumns(
      childrenArray.filter(Boolean).map(child => ({ width: child.props.width }))
    )
    if (childrenArray.find(child => child.props.checkbox)) setHasCheckbox(true)
  }, [children, setColumns, setHasCheckbox])

  const ref = useRef()

  useLayoutEffect(() => {
    if (ref.current) setHeaderHeight(ref.current.getBoundingClientRect().height)
  }, [headerHeight, setHeaderHeight])

  return (
    <>
      {isEmpty(columns) ||
        (mergeHeadersOnNoContent && (error || isEmpty(rows))) || (
          <colgroup>
            {columns.map((col, index) => (
              <col key={index} width={col.width} />
            ))}
          </colgroup>
        )}
      {noHead || (
        <thead ref={ref}>
          <tr>
            {mergeHeadersOnNoContent && (error || isEmpty(rows)) ? (
              <th />
            ) : (
              children
            )}
          </tr>
        </thead>
      )}
    </>
  )
})

export default Head

Head.displayName = 'Head'
Head.propTypes = {
  noHead: PropTypes.bool,
  children: PropTypes.node,
}
